import React, { FC } from 'react';

import { ItemInfoBox } from '../../../ItemInfoBox';
import { StyledMoreInfoModal } from './components';
import { MoreInfoModalProps } from './types';

const MoreInfoModal: FC<MoreInfoModalProps> = ({
  item,
  onClose,
  showModal,
  disableModals,
}) => {
  if (disableModals) {
    return (
      <StyledMoreInfoModal>
        <ItemInfoBox item={item} onClose={onClose} />
      </StyledMoreInfoModal>
    );
  }
  return (
    <StyledMoreInfoModal>
      <ItemInfoBox
        item={item}
        onClose={onClose}
        onErrorReportRequest={() => {
          showModal(
            {
              isOpen: true,
              position: 'center',
              itemId: item.id,
            },
            'ReportError'
          );
        }}
      />
    </StyledMoreInfoModal>
  );
};

export default MoreInfoModal;
